<ng-template #headerAddAction>
  <button
    type="button"
    class="cabinet-client-page__add-button"
    (click)="onAdd()"
  >
    + {{ 'admin.employees.add' | translate }}
  </button>
</ng-template>

<div class="admin-employees core-screen">
  @if (!embeddedInCabinetPage()) {
  <div class="title-bar">
    <div class="title-section">
      <h1 class="core-title">{{ 'admin.employees.title' | translate }}</h1>
      @if (displayCount() !== null) {
      <span class="count">{{ displayCount() }}</span>
      }
    </div>
    @if (initialized()) {
    <button class="add-button" (click)="onAdd()">
      + {{ 'admin.employees.add' | translate }}
    </button>
    }
  </div>
  }

  <lib-staff-birthdays-banner kind="employees" />

  @if (initialized()) {
  <div class="search-bar">
    <lib-not-input
      type="text"
      [placeholder]="'admin.employees.search' | translate"
      [ngModel]="searchQuery()"
      (ngModelChange)="onSearchChange($event)"
      [hideErrorBlock]="true"
    />
  </div>
  }

  <div class="employees-list" #employeesList>
    @if (items().length > 0) { @for (employee of items(); track employee.user.id) {
    <div
      class="employee-card"
      [class.deactivated]="!employee.is_active"
      [routerLink]="staffCabinetPath + '/employees/' + employee.user.id"
    >
      <div class="card-header">
        <div
          class="avatar"
          [class.avatar--has-photo]="!!employee.user.photo_url?.trim()"
        >
          @if (employee.user.photo_url?.trim(); as photoUrl) {
            <img
              class="avatar__img"
              [src]="photoUrl"
              alt=""
              loading="lazy"
              decoding="async"
            />
          } @else {
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <circle cx="12" cy="8" r="4" stroke="white" stroke-width="2" />
              <path
                d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          }
        </div>
        <div class="employee-info">
          <div class="name-row">
            <div class="name">{{ formatName(employee) }}</div>
            @if (employee.user.id === currentUserId()) {
            <span class="you-badge"
              >{{ 'admin.employees.you' | translate }}</span
            >
            } @if (!employee.is_active) {
            <span class="deactivated-badge"
              >{{ 'warehouse.status.inactive' | translate }}</span
            >
            }
          </div>
          <div class="phone">{{ employee.position }}</div>
          <div class="phone">{{ employee.user.phone }}</div>
        </div>
      </div>

      <div class="card-actions">
        <a
          class="action-button"
          (click)="$event.stopPropagation()"
          [href]="'tel:' + employee.user.phone"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
        @if (employee.user.email) {
        <a
          class="action-button"
          (click)="$event.stopPropagation()"
          [href]="'mailto:' + employee.user.email"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <polyline
              points="22,6 12,13 2,6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
        } @if (employee.telegram_link) {
        <a
          class="action-button"
          (click)="$event.stopPropagation()"
          [href]="employee.telegram_link"
          target="_blank"
          rel="noopener"
        >
          <img src="/icons/socials/telegram.svg" alt="" width="20" height="20" />
        </a>
        }
      </div>

      @if (openMenuId() === employee.user.id) {
      <div class="context-menu" (libClickOutside)="closeMenu()">
        <button class="menu-item" (click)="onEdit(employee.user.id)">
          {{ 'admin.employees.actions.edit' | translate }}
        </button>
        @if (employee.is_active && employee.user.id !== currentUserId()) {
        <button class="menu-item" (click)="onDeactivate(employee.user.id)">
          {{ 'admin.employees.actions.deactivate' | translate }}
        </button>
        } @else if (!employee.is_active) {
        <button class="menu-item" (click)="onActivate(employee.user.id)">
          {{ 'admin.employees.actions.activate' | translate }}
        </button>
        }
      </div>
      }
    </div>
    }
    @if (loadingMore()) {
    <div class="load-more-row">
      <p class="hint" role="status">{{ 'admin.staffQrScan.loading' | translate }}</p>
    </div>
    }
    } @else if (
      !loading() &&
      initialized() &&
      items().length === 0 &&
      searchQuery()
    ) {
    <div class="employees-empty-state">
      <span>&nbsp;</span>
      <div class="empty-block">
        <img src="/icons/employees-empty.svg" alt="" />
        <p class="empty-text">{{ 'admin.employees.notFound' | translate }}</p>
        <p class="empty-hint">{{ 'admin.employees.notFoundHint' | translate }}</p>
      </div>
      <span>&nbsp;</span>
    </div>
    } @else if (!loading() && initialized() && items().length === 0) {
    <div class="employees-empty-state">
      <span>&nbsp;</span>
      <div class="empty-block">
        <img src="/icons/employees-empty.svg" alt="" />
        <p class="empty-text">{{ 'admin.employees.empty' | translate }}</p>
        <p class="empty-hint">{{ 'admin.employees.emptyHint' | translate }}</p>
      </div>
      <lib-cabinet-button
        class="empty-button"
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [text]="'admin.employees.add' | translate"
        [action]="{type: 'action'}"
        (actionEvent)="onAdd()"
      />
    </div>
    } @else if (loading()) {
    <p class="hint" role="status">{{ 'admin.staffQrScan.loading' | translate }}</p>
    }
  </div>
</div>
